const CorporateFareOutlined = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <mask
      id="mask0_1683_11362"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="18"
    >
      <rect width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1683_11362)">
      <path
        d="M1.77344 15.4336V2.30859H8.89825V5.30859H16.2252V15.4336H1.77344ZM2.89825 14.3086H7.77344V12.4336H2.89825V14.3086ZM2.89825 11.3086H7.77344V9.43359H2.89825V11.3086ZM2.89825 8.30859H7.77344V6.43359H2.89825V8.30859ZM2.89825 5.30859H7.77344V3.43359H2.89825V5.30859ZM8.89825 14.3086H15.1004V6.43359H8.89825V14.3086ZM10.5426 9.43359V8.30859H13.3118V9.43359H10.5426ZM10.5426 12.4336V11.3086H13.3118V12.4336H10.5426Z"
        fill="#535862"
      />
    </g>
  </svg>
);

export default CorporateFareOutlined;
